import PropTypes from 'prop-types';
import React from 'react';

import {IMASK_PATTERNS} from '../../constants/imaskPatterns';
import {EC_REPRESENTATIVE_DATA} from '../../constants/typesMessages';
import {IMaskInputWrapper} from '../../shared/components/IMaskInputWrapper';
import {useChatStore} from '../../store/slices/chatStore';
import DefaultInput from '../GenericEntryFields/DefaultInput';
import './RepresentativeDataFields.style.scss';

const RepresentativeDataFields = (props) => {
  const responseFlow = useChatStore((state) => state.responseFlow);

  return (
    <div
      data-testid="flow-representative-data"
      data-aut-test="flow-representative-data"
      id="flow-representative-data"
      className="user-input-representative"
    >
      {responseFlow === EC_REPRESENTATIVE_DATA.CPF && (
        <IMaskInputWrapper
          key={EC_REPRESENTATIVE_DATA.CPF}
          className="input-message"
          type="text"
          name="message"
          id="message"
          data-testid="message"
          onChange={props.onChange}
          mask={IMASK_PATTERNS.CPF}
          autoComplete="off"
          placeholder="Digite seu CPF"
        />
      )}
      {responseFlow === EC_REPRESENTATIVE_DATA.EMAIL && (
        <DefaultInput
          value={props.value}
          onChange={props.onChange}
          placeholder="Digite seu e-mail"
        />
      )}
      {responseFlow === EC_REPRESENTATIVE_DATA.NAME && (
        <DefaultInput
          value={props.value}
          onChange={props.onChange}
          placeholder="Digite seu nome"
        />
      )}
      {responseFlow === EC_REPRESENTATIVE_DATA.BIRTH && (
        <IMaskInputWrapper
          key={EC_REPRESENTATIVE_DATA.BIRTH}
          className="input-message"
          type="text"
          name="message"
          id="message"
          data-testid="message"
          onChange={props.onChange}
          mask={IMASK_PATTERNS.BIRTHDATE}
          autoComplete="off"
          placeholder="Digite sua data de nascimento"
        />
      )}
      {responseFlow === EC_REPRESENTATIVE_DATA.PHONE && (
        <IMaskInputWrapper
          key={EC_REPRESENTATIVE_DATA.PHONE}
          className="input-message"
          type="text"
          name="message"
          id="message"
          data-testid="message"
          onChange={props.onChange}
          mask={IMASK_PATTERNS.PHONE}
          autoComplete="off"
          placeholder="Digite seu telefone"
        />
      )}
    </div>
  );
};

RepresentativeDataFields.propTypes = {
  value: PropTypes.string,
  onChange: PropTypes.func
};

export default RepresentativeDataFields;
